import React, { useContext } from "react";
import { BotBubleType1, UserBubleType1 } from "./type1";
import { BotBubleType2, UserBubleType2 } from "./type2";
import { BotBubleType3, UserBubleType3 } from "./type3";
import { AppContext } from "../../../../context/appContext";


export function UserBubble({children}: any) {
  const {widgetConfig} = useContext(AppContext);
  const type: string = widgetConfig.bubbleType || "type1"
  let Component = null;
  switch (type) {
    case "type1": Component = UserBubleType1; break;
    case "type2": Component = UserBubleType2; break;
    case "type3": Component = UserBubleType3; break;
    default: Component = UserBubleType1;
  }
    
  return (
    <Component customStyles={widgetConfig?.customStyles}>
      {children}
    </Component>
  )
}

export function BotBubble({children}: any) {
  const {widgetConfig} = useContext(AppContext);
  const type: string = widgetConfig.bubbleType || "type1"
  let Component = null;
  switch (type) {
    case "type1": Component = BotBubleType1; break;
    case "type2": Component = BotBubleType2; break;
    case "type3": Component = BotBubleType3; break;
    default: Component = BotBubleType1;
  }
  return (
    <Component customStyles={widgetConfig?.customStyles}>
      {children}
    </Component>
  )
}
